import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    localStorage.setItem("invitePrenom", prenom);
    localStorage.setItem("inviteNom", nom);
    localStorage.setItem("inviteEmail", email);

    navigate("/invitation");
  };

  return (
    <div className="container">
      <h1>Bienvenue sur le site du Mariage Participatif de Xavina et Samuel</h1>

      <form onSubmit={handleSubmit} className="form">
        <input
          type="text"
          placeholder="Prénom"
          value={prenom}
          onChange={(e) => setPrenom(e.target.value.trim())}
          required
        />
        <input
          type="text"
          placeholder="Nom"
          value={nom}
          onChange={(e) => setNom(e.target.value.trim())}
          required
        />
        <input
          type="email"
          autoCapitalize="none"
          autoCorrect="off"
          inputMode="email"
          placeholder="Adresse email"
          value={email}
          onChange={(e) => setEmail(e.target.value.trim().toLowerCase())}
          required
        />
              <h2>Le 16 mai 2026 à partir de 14h</h2>
              <div className="center">
      <img width='300' src="/images/ninasam.jpg" alt="Les mariés" />
      <h2><strong>Lieu : </strong> Amar et Hôtes<br />
        Rue de l'Abattoir 34, 5060 Sambreville</h2>
              </div>


        <button type="submit">Accéder à l'invitation</button>
      </form>
    </div>
  );
}
